<template>
  <div>
    <v-row v-if="context == 'diff'">
      <v-col
        cols="6"
        class="text-h6 font-weight-bold text-center"
      >
        Entrada
      </v-col>
      <v-col
        cols="6"
        class="text-h6 font-weight-bold text-center"
      >
        Saída
      </v-col>
    </v-row>
    <div class="app-align-items-center">
      <v-spacer v-if="context == 'diff'" />
      <v-radio-group
        v-model="configOptionModel"
        row
        class="mx-2"
      >
        <v-radio
          v-for="option in radioOptions"
          :key="option.value"
          :label="option.text"
          :value="option.value"
        />
      </v-radio-group>
      <v-spacer v-if="context != 'diff'" />
      <BaseButton
        v-if="context === 'output'"
        size="small"
        class="my-0 mx-3"
        color="primary"
        @click="$emit('showDiffModal')"
      >
        Diff
      </BaseButton>
    </div>
    <template v-if="configOptionModel === 'schema'">
      <div
        class="d-flex flex-column"
        :class="{'align-end': context === 'diff', 'align-start': context !== 'diff'}"
      >
        <h4
          v-if="schemaTitle"
          class="color--text-black-054"
        >
          {{ schemaTitle }}
        </h4>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <BaseButton
              :has-icon="true"
              color="primary"
              class="mx-0 my-3 pa-4"
              size="small"
              v-bind="attrs"
              v-on="on"
              @click="showProtobufSchema = !showProtobufSchema"
            >
              <v-icon>{{ showProtobufSchema ? 'mdi-menu-open' : 'mdi-menu-close' }}</v-icon>
            </BaseButton>
          </template>
          <span>{{ showProtobufSchema ? 'Ocultar Schemas de Protobuf' : 'Mostrar schemas de Protobuf' }}</span>
        </v-tooltip>
      </div>
      <v-row>
        <v-col
          v-if="showProtobufSchema && context !== 'diff'"
          sm="4"
          class="px-0"
        >
          <ProtobofSchema
            @insert-value="handleValue"
          />
        </v-col>
        <v-col
          :cols="!showProtobufSchema ? 12 : showProtobufSchema && context === 'diff' ? 10 : 8"
        >
          <div class="app-align-items-center">
            <template v-if="context == 'diff'">
              <BaseInput
                v-model="schemaInputModel"
                label="Schema"
                dense
                disabled
                class="mr-4"
                :style="{ width: getWidthInput() }"
              />
              <BaseInput
                v-model="optionsInputModel"
                label="Options"
                dense
                disabled
                class="mr-4"
                :style="{ width: getWidthInput() }"
              />
              <v-spacer />
            </template>
            <BaseInput
              id="field-text"
              v-model="schemaModel"
              label="Schema"
              dense
              class="mr-4"
              :style="{ width: getWidthInput() }"
              @click="handleClick('field-text')"
            />
            <v-select
              v-model="optionsModel"
              :items="listSchemas"
              label="Options"
              dense
              class="mr-4"
              clearable
              :style="{ width: getWidthInput(), 'max-width': getWidthInput() }"
              @change="changeOptions()"
            />
            <v-spacer v-if="context != 'diff'" />
            <v-tooltip
              v-if="context === 'output' || context == 'diff'"
              bottom
            >
              <template v-slot:activator="{ on }">
                <BaseButton
                  :has-icon="false"
                  type="fab"
                  color="primary"
                  size="x-small"
                  v-on="on"
                  @click="emitHandleClick()"
                >
                  <v-icon>mdi-swap-horizontal</v-icon>
                </BaseButton>
              </template>
              <span>Transformar</span>
            </v-tooltip>
          </div>
          <template v-if="context !== 'diff'">
            <BaseCodemirror
              ref="field-codemirror"
              v-model="payloadModel"
              cm-ref="field-codemirror"
              :title="codemirrorTitle"
              :read-only="context === 'output'"
              :lang="context === 'input' ? 'json' : 'groovy'"
              class="my-4"
              @focus="handleClick('field-codemirror')"
            />
          </template>
          <template v-if="context == 'diff'">
            <CodeDiff
              :old-string="objectValue.oldValue"
              :new-string="objectValue.newValue"
              language="JSON"
              output-format="side-by-side"
            />
          </template>
        </v-col>
        <v-col
          v-if="showProtobufSchema && context === 'diff'"
          class="px-0"
        >
          <ProtobofSchema
            :full-height="true"
            @insert-value="handleValue"
          />
        </v-col>
      </v-row>
    </template>
    <template v-else-if="configOptionModel === 'fromPID'">
      <BaseInput
        v-model="fromPIDModel"
        :rules="[isValid]"
        label="Uuid do processador"
        class="mr-2 my-4"
        @change="emitChangedValues()"
      />
    </template>
    <template v-else-if="configOptionModel === 'bytes'">
      <div
        v-if="context !== 'input'"
        class="app-align-items-center"
      >
        <v-spacer v-if="context == 'diff'" />
        <BaseButton
          size="small"
          class="ma-0 mt-4"
          color="primary"
          @click="$emit('encodeDecodeBase64')"
        >
          {{ objectValue.isBase64 ? 'Decodificado' : 'Base64' }}
        </BaseButton>
      </div>
      <div v-else>
        Escolha entre dados base64 ou texto para ser codificado.
      </div>
      <v-row>
        <v-col
          v-if="context === 'input'"
          class="mx-0 my-6 pa-0"
          cols="2"
        >
          <v-radio-group v-model="configByteOptionModel">
            <v-radio
              v-for="option in byteRadioOptions"
              :key="option.value"
              :label="option.text"
              :value="option.value"
            />
          </v-radio-group>
        </v-col>
        <v-col
          class="ma-0 pa-0"
          :cols="context === 'input' ? 10 : 12"
        >
          <CodeDiff
            v-if="context == 'diff'"
            :old-string="objectValue.oldValue"
            :new-string="objectValue.newValue"
            language="JSON"
            output-format="side-by-side"
          />
          <BaseCodemirror
            v-else
            ref="field-codemirror"
            v-model="payloadModel"
            cm-ref="field-codemirror"
            :read-only="context === 'output'"
            class="my-4"
            @focus="handleClick('field-codemirror')"
          />
        </v-col>
      </v-row>
    </template>
  </div>
</template>
<script>
import BaseCodemirror from '../../BaseCodemirror'
import ProtobofSchema from './ProtobofSchema'
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import { CodeDiff } from 'v-code-diff'
import UtilsLocalStorage from '../../../mixins/UtilsLocalStorage'
import UtilsCodemirror from '../../../mixins/UtilsCodemirror'

export default {
  components: { BaseCodemirror, ProtobofSchema, CodeDiff },
  mixins: [ BaseSnackbarConfiguration, UtilsLocalStorage, UtilsCodemirror ],
  props: {
    listSchemas: {
      type: Array,
      required: true
    },
    radioOptions: {
      type: Array,
      required: true
    },
    codemirrorTitle: {
      type: String,
      required: false,
      default: null
    },
    schemaTitle: {
      type: String,
      required: false,
      default: null
    },
    objectValue: {
      type: Object,
      required: false,
      default: null
    },
    optionModel: {
      type: String,
      required: false,
      default: 'schema',
      validator: (value) => ['schema', 'bytes', 'fromPID'].includes(value)
    },
    context: {
      type: String,
      required: true,
      validator: (value) => ['input', 'output', 'diff'].includes(value)
    },
    byteRadioOptions: {
      type: Array,
      required: false,
      default: null
    }
  },
  data: () => ({
    itemId: '',
    showProtobufSchema: false,
    schemaModel: '',
    schemaInputModel: '',
    payloadModel: '',
    optionsModel: '',
    optionsInputModel: '',
    configOptionModel: '',
    configByteOptionModel: '',
    fromPIDModel: null,
  }),
  watch: {
    objectValue: {
      async handler(val) {
        this.setObjectValues()
      },
      deep: true
    },
    schemaModel(){
      if(this.context === 'input'){
        this.emitChangedValues()
      }
    },
    payloadModel(){
      this.emitChangedValues()
    },
    configOptionModel(){
      this.emitChangedValues()
      if(this.context === 'output'){
        this.schemaModel = '';
        this.optionsModel = '';
      }
    },
    configByteOptionModel(){
      this.emitChangedValues()
    }
  },
  created(){
    this.configOptionModel = this.getItemTestLocalStorage('configOption') || this.optionModel;
    this.configByteOptionModel = this.getItemTestLocalStorage('byteOption')
    this.schemaInputModel = this.getItemTestLocalStorage('schema');
    this.optionsInputModel = this.getItemTestLocalStorage('options').import_schemas ? this.getItemTestLocalStorage('options').import_schemas : '';

    if(this.objectValue){
      this.setObjectValues()
    }
  },
  methods: {
    handleValue(value) {
      this.insertValueField(value)
    },
    handleClick(value) {
      this.itemId = value
    },
    insertValueField(value){
      if(this.itemId === 'field-text') {
        this.schemaModel = value
      } else {
        this.setCodemirrorValue('field-codemirror', value)
      }
    },
    setObjectValues(){
      let { schema, payload, options, fromPID } = this.objectValue
      this.optionsModel = options && options.import_schemas ? options.import_schemas : null;
      this.fromPIDModel = fromPID;
      this.itemId = 'field-text';

      if(schema){
        this.schemaModel = schema;
      }

      if(payload){
        setTimeout(() => {
          this.setCodemirrorValue('field-codemirror', this.stringifyValue(payload))
        }, 200)
      }
    },
    emitChangedValues(){
      this.$emit('hasChangedValues', {
        configOption: this.configOptionModel,
        byteOption: this.configByteOptionModel,
        fromPIDModel: this.fromPIDModel,
        configObject: {
          schema: this.schemaModel,
          payload: this.payloadModel,
          options: this.optionsModel
        }
      })
    },
    emitHandleClick() {
      this.$emit('handleClick', {
        fromPIDModel: this.fromPIDModel,
        configObject: {
          schema: this.schemaModel,
          payload: this.payloadModel,
          options: this.optionsModel
        }
      })
    },
    getWidthInput(){
      let width = {
        "input": "50%",
        "output": "40%",
        "diff": "20%",
      }
      return width[this.context]
    },
    changeOptions(){
      if(this.context === 'input'){
        this.emitChangedValues()
      }
    }
  }
}
</script>
